/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: keep the shopper in-context whenever drawer markup is present.
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      const initialDrawer = document.querySelector('theme-drawer#cart-drawer');

      if (!initialDrawer) {
        window.location.href = Theme.routes.cart_url || '/cart';
        return;
      }

      try {
        await window.KervelanCartDrawerRuntime?.ensureShell?.();
        await customElements.whenDefined('theme-drawer');
      } catch (error) {
        console.warn('[KERVELAN] Cart drawer shell failed to load', error);
        return;
      }

      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') {
        console.warn('[KERVELAN] Cart drawer shell is unavailable');
        return;
      }

      drawer.open();
      window.KervelanCartDrawerRuntime?.ensureCore?.().catch(() => {});
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
